export default __webpack_public_path__ + "static/media/Archpriest's Tunic of the Limitless Cipher.ac1fe09b.jpg";